<template>
  <img
    :src="parsedSrc"
    :loading="loading"
    v-bind="$attrs"

  />
</template>

<script setup lang="ts">

const props = withDefaults(defineProps<{
  src: string,
  loading: string,
}>(), {
  loading: 'lazy',
});
const IMG_PREFIX = /^\/static-file(\/resources)?/;
const { $curHost = {} } = useNuxtApp();
const imgCdnHost = ref($curHost.imgCdnHost)
onMounted(()=>{

setTimeout(()=>{
  if (imgCdnHost.value!==$curHost.imgCdnHost) {
    imgCdnHost.value=$curHost.imgCdnHost
  }
},1000)
})

// const config = useRuntimeConfig();
const parsedSrc = computed(() => props.src?.replace(IMG_PREFIX, imgCdnHost.value) ?? props.src);
</script>

